import { ToastContainer } from "react-toastify";
import "./App.css";
import Layout from "./layout/index";
import ThemeProvider from "./theme";
import "react-quill/dist/quill.snow.css";
import "react-toastify/dist/ReactToastify.css";
import { useAuth } from "./hooks/useAuth";

function App(props) {
  // Handle authentication state
  useAuth();

  return (
    <>
      <ThemeProvider>
        <Layout>{props.children}</Layout>
      </ThemeProvider>
      <ToastContainer />
    </>
  );
}

export default App;
